export const getValueParam = (param: string):string =>{
    // Obtém a URL atual
    var url = new URL(window.location.href);

    // Obtém o valor do parâmetro "channel"
    var valueParam = url.searchParams.get(param) as string; 

    // Verifica se o parâmetro "channel" foi encontrado na URL
    if (valueParam !== null) {
        console.log("Valor do parâmetro 'channel': " + valueParam);
    } else {
        console.log("O parâmetro 'channel' não foi encontrado na URL.");
    }
    return valueParam
}


// Exporta a função getConfig para torná-la disponível para outros módulos
export const config = () =>{
    const configString = localStorage.getItem('config');
    if (configString) {
        return JSON.parse(configString);
    } else {
        return null;
    }
}


/**
 * Obtém a data e hora atual formatada conforme o formato fornecido.
 *
 * @param {string} [formato="AA:MM:DD hh:mm:ss"] - O formato desejado. Pode conter placeholders como "AA", "MM", "DD", "hh", "mm", "ss".
 * @returns {string} - A data e hora formatada.
 * @example
 * // Exemplo de uso com formato personalizado
 * const dataFormatada1 = obterDataAtual("AA/MM/DD");
 * console.log(dataFormatada1); // Exemplo: "22/01/04"
 * 
 * @example
 * // Exemplo de uso com formato padrão
 * const dataFormatada2 = obterDataAtual();
 * console.log(dataFormatada2); // Exemplo: "22:01:04 14:30:45"
 */
export const obterDataAtual = (formato = "AA:MM:DD hh:mm:ss") => {
    const dataAtual = new Date();
    
    const ano = String(dataAtual.getFullYear()).slice(-2);
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    
    const horas = String(dataAtual.getHours()).padStart(2, '0');
    const minutos = String(dataAtual.getMinutes()).padStart(2, '0');
    const segundos = String(dataAtual.getSeconds()).padStart(2, '0');

    let resultado = formato.replace("AA", ano);
    resultado = resultado.replace("MM", mes);
    resultado = resultado.replace("DD", dia);
    resultado = resultado.replace("hh", horas);
    resultado = resultado.replace("mm", minutos);
    resultado = resultado.replace("ss", segundos);

    return resultado;
}

